module.exports = __webpack_public_path__ + "img/logo2.5b0d4db7.png";